import { Component, OnDestroy, OnInit } from '@angular/core';
import { interval, Subject, timer } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { RoutingService } from '@shared/services/routing.service';

const redirectTimeout = 30; //sec

@Component({
  selector: 'app-preloader-page',
  templateUrl: './preloader-page.component.html',
  styleUrls: ['./preloader-page.component.scss']
})
export class PreloaderPageComponent implements OnInit, OnDestroy {
  private destroySubject = new Subject();

  // todo grammar
  loaderPhrases = [
    'contacting the terminal',
    'proceeding request',
    '',
    'call the manager',
    'adjusting the waiters'
  ];

  constructor(private routerService: RoutingService) {
    console.log(`PreloaderPageComponent`);
  }

  ngOnInit(): void {
    timer(redirectTimeout*1000)
      .pipe(takeUntil(this.destroySubject))
      .subscribe((x) => {
        console.log(`redirectTimeout`);
        this.routerService.redirectToLco();
      })
  }

  ngOnDestroy() {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

}
